import {StyledBaseProps} from "@betrue/shared/interfaces";
import styled from "styled-components";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useMediaQuery,
  useTheme
} from "@mui/material";
import * as React from "react";

export interface DialogBaseViewProps extends StyledBaseProps {
  isOpen?: boolean
  dialogTitle: string
  handleSubmit: () => void
  handleClose: () => void
  dialogSubtitle: string
  dialogCancel: string
  dialogSave: string
}

export const DialogBaseView = styled((props: DialogBaseViewProps) => {

  const theme = useTheme();

  const matches = useMediaQuery(theme.breakpoints.up('md'));

  return (<div className={props.className}>
    <Dialog
      disableAutoFocus={true}
      disableEnforceFocus={true}
      disableRestoreFocus={true}
      fullScreen={!matches}
      open={props.isOpen}
      disablePortal={true}
      onClose={() => {
        props.handleClose()
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">

      <DialogTitle id="customized-dialog-title">
        {props.dialogTitle ? props.dialogTitle : 'Dites-nous Cheeeeese 🤳'}
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          {props.dialogSubtitle ? props.dialogSubtitle : 'Votre plus beau sourire en glisser-déposer ou cliquer' +
            ' chercher'}
        </DialogContentText>

        {props.children}

      </DialogContent>
      <DialogActions>

        <Button onClick={() => props.handleClose()} color={"warning"}>
          {props.dialogCancel ? props.dialogCancel : 'Annuler'}
        </Button>

        <Button autoFocus onClick={props.handleSubmit} color={"primary"}>
          {props.dialogSave ? props.dialogSave : 'Valider'}
        </Button>
      </DialogActions>
    </Dialog>

  </div>)

})`

  & .bt-drop-zone {
    flex: 1;
    width: 250px;
    height: 250px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border-width: 2px;
    border-radius: 2px;
    border-color: #eeeeee;
    border-style: dashed;
    background-color: #fafafa;
    color: #bdbdbd;
    outline: none;
    transition: border .24s ease-in-out;
  }

  & .bt-drop-zone:focus {
    border-color: #2196f3;
  }

`

